import { Component, Input, OnInit } from '@angular/core';
import { EmopMenuType } from '../../common/EmopMenuType';
import { EmopUtilsService } from '../..//services/emop-utils.service';
import { EmopMenuClass } from '../../../app/class/EmopMenuClass/EmopMenuClass';

@Component({
  selector: 'emop-menu',
  templateUrl: './emop-menu.component.html',
  styleUrls: ['./emop-menu.component.scss']
})
export class EmopMenuComponent implements OnInit {
  @Input() data: EmopMenuClass;
  @Input() showTips: boolean = false;
  constructor(
  ) { }
  ngOnInit(): void {
    if (!this.data) console.error('emop-menu菜单组件初始化失败\n请传入%cEmopMenuClass', 'background: #aaaaaa50;padding:2px 5px;border-radius:5px;');
  }
}
